module.exports = __webpack_public_path__ + "img/icon-email-failed.f30f9dc2.svg";